import { ToggleButton, type ToggleButtonProps } from "@mui/material";
import { CheckIcon } from "@phosphor-icons/react";

type Props = Pick<
  ToggleButtonProps,
  "value" | "onChange" | "children" | "selected"
>;

export function ListToggleButton({
  value,
  onChange,
  selected,
  children,
}: Props) {
  return (
    <ToggleButton
      onChange={onChange}
      sx={{
        border: "none",
        borderBottom: "1px solid var(--color-stroke-neutral-soft)",
        borderRadius: "0",
        textTransform: "unset",
        padding: "16px 8px",
        "&.Mui-selected": {
          backgroundColor: "initial",
          color: "initial",
        },
        "&:hover": {
          backgroundColor: "var(--color-surface-neutral-soft) !important",
        },
      }}
      selected={selected}
      value={value}
    >
      <div className="flex w-full">
        <span className="inline-flex grow items-center gap-4 text-base font-medium text-text-primary">
          {children}
        </span>

        {selected ? (
          <CheckIcon
            size={20}
            className="fill-text-interactive"
            weight="bold"
            aria-hidden
          />
        ) : null}
      </div>
    </ToggleButton>
  );
}
